import * as React from "react";

import { Divider, Form, Input, message, Select, Space, Tag, Tooltip, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useFetch } from "../../utils/hooks/useFetch";

const { Option } = Select;

export default function SelectTypes({
  url: propsUrl,
  setCurrentValueType: propsSetCurrentValueType,
  hasChanged: propsHasChanged,
  label: propsLabel,
  name: propsName,
  rules: propsRules,
  placeholder: propsPlaceHolder,
  isDisabled: propsIsDisabled,
  isTextFiltered: propsIsTextFiltered,
  allowClear: propsAllowClear,
  formProps,
  values: propsValues,
  toolTipText: propsToolTipText,
  ...props
}) {
  const isCancelled = React.useRef(false);
  const [doFetch] = useFetch();
  const [valueTypes, setValueTypes] = React.useState([]);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [name, setName] = React.useState("");

  React.useEffect(
    () => {
      getValueTypes();
      return () => {
        isCancelled.current = true;
      };
    }, // eslint-disable-next-line
    []
  );

  function getValueTypes() {

    if(propsValues) {
      setValueTypes(propsValues);
      return;
    }
    doFetch(propsUrl).then((response) => {
      if (response.isSuccess) {
        if (!isCancelled.current) {
          setValueTypes(response.result);
        }
        return;
      }

      message.error(`Failed to get ${propsName}`);
    });
  }

  function setCurrentAssetType(assetTypeId) {
    if (!propsSetCurrentValueType) {
      return;
    }
    propsSetCurrentValueType(valueTypes.find((_) => _.id === assetTypeId));
  }

  const handleChange = (value, options) => {
    if (props.mode === "multiple") {
      setSelectedItems([selectedItems]);
      propsHasChanged(value);
      return;
    }
    setCurrentAssetType(value);
    if (propsHasChanged) {
      propsHasChanged(options?.key);
    }
  };

  const onNameChange = (event) => {
    setName(event.target.value);
  };

  function onClickAddNewRecord() {
    if (name !== "") {
      setValueTypes([
        ...valueTypes,
        {
          id: -1,
          code: name,
        },
      ]);

      setName("");
    }
  }

  function valueTypeOptions(mode) {
    if (mode === "multiple") {
      const filteredOptions = valueTypes?.filter(
        (o) => !selectedItems?.includes(o)
      );
      filteredOptions.map((type) => (
        <Option value={type.id} key={type.id}>
          {type.name}
        </Option>
      ));
    }
    return valueTypes.map((type) => {
      return (
        <Option
          value={!propsIsTextFiltered ? type.id : type.code}
          key={type.id}
        >
          {type.name ?? type?.item?.name}
        </Option>
      );
    });
  }

  const tagRender = (props) => {
    const { label, closable, onClose } = props;

    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    return (
      <Tag
        color="blue"
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{
          marginRight: 4,
          marginLeft: 4
        }}
      >
        {label}
      </Tag>
    );
  };

  return (
    <Form.Item
      label={propsLabel}
      name={propsName}
      rules={propsRules}
      tooltip={propsToolTipText &&
        <Tooltip>
            <span>{propsToolTipText}</span>
        </Tooltip>
    }
      {...formProps}
    >
      <Select
        name={propsName}
        showSearch
        placeholder={propsPlaceHolder}
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        filterSort={(optionA, optionB) =>
          optionA.children
            ?.toLowerCase()
            .localeCompare(optionB.children?.toLowerCase())
        }
        onChange={handleChange}
        disabled={propsIsDisabled}
        allowClear={propsAllowClear}
        tagRender={tagRender}
        dropdownRender={(menu) => (
          <>
            {menu}
            {propsIsTextFiltered && (
              <>
                <Divider style={{ margin: "8px 0" }} />
                <Space align="center" style={{ padding: "0 8px 4px" }}>
                  <Input
                    placeholder={propsPlaceHolder}
                    value={name}
                    onChange={onNameChange}
                  />
                  <Typography.Link
                    onClick={onClickAddNewRecord}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <PlusOutlined /> {"Add"}
                  </Typography.Link>
                </Space>
              </>
            )}
          </>
        )}
        {...props}
      >
        {valueTypeOptions(props.mode)}
      </Select>
    </Form.Item>
  );
}
